var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v("Costo por Proyecto " + _vm._s(_vm.form.nombre))]),
          _vm._v(" "),
          _c("label", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.estado == "N",
                    expression: "form.estado == 'N'"
                  }
                ],
                staticClass: "noti-secondary"
              },
              [_vm._v("Estado: "), _c("strong", [_vm._v("NUEVO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.estado == "A",
                    expression: "form.estado == 'A'"
                  }
                ],
                staticClass: "noti-success"
              },
              [_vm._v("Estado: "), _c("strong", [_vm._v("ACTIVO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.estado == "I",
                    expression: "form.estado == 'I'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_vm._v("Estado: "), _c("strong", [_vm._v("INACTIVO")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _vm.consultar
            ? _c(
                "button",
                {
                  staticClass: "btn-info btn--bigger",
                  on: {
                    click: function($event) {
                      return _vm.botonBuscar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-search" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Buscar")])
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main" }, [
        _c("div", { staticClass: "layout__main-form" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              disabled: _vm.disabledInput,
                              tooltip: _vm.selectedProyecto
                                ? _vm.selectedProyecto.nombre
                                : null,
                              id: "proyecto_id",
                              placeholder: "Busque y seleccione...",
                              label: "nombre",
                              options: _vm.optionProyectos
                            },
                            on: {
                              search: _vm.onSearchProyecto,
                              input: _vm.inputProyecto
                            },
                            model: {
                              value: _vm.selectedProyecto,
                              callback: function($$v) {
                                _vm.selectedProyecto = $$v
                              },
                              expression: "selectedProyecto"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "proyecto_id" } }, [
                            _vm._v("Proyecto*")
                          ]),
                          _vm._v(" "),
                          _vm.errores.proyecto_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.proyecto_id[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-info",
                          attrs: {
                            disabled: _vm.disabledInput,
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              return _vm.buscarProyecto()
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-search" })]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            disabled: _vm.disabledInput,
                            id: "fecha",
                            locale: "es",
                            "only-datetime": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD HH:mm",
                            formatted: "YYYY-MM-DD HH:mm",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fecha,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha", $$v)
                            },
                            expression: "form.fecha"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Fecha*")]),
                        _vm._v(" "),
                        _vm.errores.fecha
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.fecha[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            disabled: _vm.disabledInput,
                            id: "descripcion",
                            placeholder: "Escriba una descripción..."
                          },
                          model: {
                            value: _vm.form.descripcion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "descripcion", $$v)
                            },
                            expression: "form.descripcion"
                          }
                        },
                        [
                          _c("span", [_vm._v("Descripción*")]),
                          _vm._v(" "),
                          _vm.errores.descripcion
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.errores.descripcion[0]) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            disabled: _vm.disabledInput,
                            id: "valor",
                            vMoney: "",
                            format: _vm.money,
                            type: "tel",
                            placeholder: "$ ##.##"
                          },
                          model: {
                            value: _vm.form.valor,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "valor", $$v)
                            },
                            expression: "form.valor"
                          }
                        },
                        [
                          _c("span", [_vm._v("Valor*")]),
                          _vm._v(" "),
                          _vm.errores.valor
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.errores.valor[0]) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            disabled: _vm.disabledInput,
                            id: "observacion",
                            placeholder: "Escriba una observación..."
                          },
                          model: {
                            value: _vm.form.observacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "observacion", $$v)
                            },
                            expression: "form.observacion"
                          }
                        },
                        [
                          _c("span", [_vm._v("Observación")]),
                          _vm._v(" "),
                          _vm.errores.observacion
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.errores.observacion[0]) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main-buttons" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _vm.crear && _vm.editar
                ? _c(
                    "button",
                    {
                      staticClass: "btn-success",
                      attrs: {
                        disabled: _vm.form.estado == "I",
                        type: "button"
                      },
                      on: {
                        click: function($event) {
                          return _vm.botonGuardar()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-save" }),
                      _c("span", [_vm._v("Guardar")])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-light btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.botonLimpiar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _c("span", [_vm._v("Nueva")])
                ]
              ),
              _vm._v(" "),
              _vm.eliminar
                ? _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.tieneId &&
                            _vm.form.estado != "N" && _vm.form.estado != "I",
                          expression:
                            "tieneId && (form.estado != 'N' && form.estado != 'I')"
                        }
                      ],
                      staticClass: "btn-danger btn--text",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.botonAnular()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-ban" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Eliminar")])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tieneId && _vm.form.estado == "I",
                      expression: "tieneId && form.estado == 'I'"
                    }
                  ],
                  staticClass: "btn-success btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.botonReactivar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-power-off" }),
                  _c("span", [_vm._v("Re-activar")])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "80%",
            height: "auto",
            scrollable: true,
            name: "modalListaCostoProyectos"
          }
        },
        [
          _c("listaCostoProyectos", {
            attrs: { enabledExcel: "" },
            on: { selected: _vm.seleccionarCostoProyecto }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5331752", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5331752","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/procesos/CostoProyecto.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b5331752","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/procesos/CostoProyecto.vue
// module chunks = 0